import { FraSlider } from "Components/fra-m-slider/fra-m-slider";
import { getCurrentMQ } from "Helper/domHelper";

/**
 * Custom Element to add visibility states to slides in viewport
 */
class FRATeaserSlider extends FraSlider {
  static VISIBLE_COUNT_MQ5 = 3;
  static VISIBLE_COUNT_MQ3 = 2;
  static VISIBLE_COUNT_MQ1 = 1;

  constructor() {
    super();

    this.visibleSlideCount = null;
  }

  /**
   * check how many slides are visible on each MQ
   */
  setVisibleSlideCount(): void {
    if (getCurrentMQ() === "MQ5") {
      this.visibleSlideCount = FRATeaserSlider.VISIBLE_COUNT_MQ5;
    } else if (getCurrentMQ() === "MQ4" || getCurrentMQ() === "MQ3") {
      this.visibleSlideCount = FRATeaserSlider.VISIBLE_COUNT_MQ3;
    } else {
      this.visibleSlideCount = FRATeaserSlider.VISIBLE_COUNT_MQ1;
    }
    this.handleSlideVisibility();
  }
}

customElements.define("fra-m-teaser-slider", FRATeaserSlider);

export default FRATeaserSlider;
